import React from "react";
import { Card } from "antd";
import {
  TeamOutlined,
  CalendarOutlined,
  FileTextOutlined,
  GiftOutlined
} from "@ant-design/icons";
import "./Overview.css";

const QuickLinks = () => {
  const linkTiles = [
    {
      title: "Employee Management",
      icon: <TeamOutlined style={{ fontSize: "28px", color: "#4a90e2" }} />,
      links: [
        { text: "All Employees", href: "/dashboard/team/employeelist" }
      ]
    },
    {
      title: "Leave & Attendance",
      icon: <CalendarOutlined style={{ fontSize: "28px", color: "#f5a623" }} />,
      links: [
        { text: "Leave Requests", href: "/dashboard/leave/applyleave" },
        { text: "Monthly Roster", href: "/dashboard/page/rosterviewpage" }
      ]
    },
    {
      title: "Resources",
      icon: <FileTextOutlined style={{ fontSize: "28px", color: "#7ed321" }} />,
      links: [
        { text: "Policies", href: "/dashboard/organization/policypage" },
        { text: "Announcements", href: "/dashboard/announcements" }
      ]
    },
    {
      title: "Holidays",
      icon: <GiftOutlined style={{ fontSize: "28px", color: "#d0021b" }} />,
      links: [
        { text: " US Holidays", href: "/dashboard/organization/holidays" }
      ]
    }
  ];

  return (
    <div className="overview1-container">
      <header className="overview1-header">
        <h1>Quick Links</h1>
      </header>

      <section className="service-area">
        <div className="service-tiles">
          {linkTiles.map((tile, idx) => (
            <Card
              key={idx}
              className="quicklink-card"
              hoverable
              bordered={false}
              title={
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  {tile.icon}
                  <span>{tile.title}</span>
                </div>
              }
            >
              <ul>
                {tile.links.map((link, i) => (
                  <li key={i}>
                    <a href={link.href}>{link.text}</a>
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
};

export default QuickLinks;
